import type { OnboardingPolicy } from '@/regions/onboardingPolicy'
import { buildActionList } from './actionList'

export const nlOnboarding: OnboardingPolicy = {
  buildActions: buildActionList,
  allowedPaths: [
    '/action/askbsn',
    '/action/identificationInfo',
    '/action/onboardGeneralQstrInfo',
    '/action/onboardMedicalQstrInfo',
  ],
}
